import { getState } from '~src/state';

export const returnToMenu = () => {
  const servizio = getState('selected.servizio');
  const projectType = getState('selected.tipo');
  const format = getState('selected.formato');
  const templatesCategory = getState('selected.templatesCategory');

  const queryString = [];

  if (servizio && servizio.objectId) {
    queryString.push(`servizio=${servizio.objectId}`);
  }

  if (projectType.objectId) {
    queryString.push(`tipo=${projectType.objectId}`);
  }

  if (format.objectId) {
    queryString.push(`formato=${format.objectId}`);
  }

  if (templatesCategory.objectId) {
    queryString.push(`tc=${templatesCategory.objectId}`);
  }

  const link = `${window.location.origin}${
    process.env.ROUTE_START
  }?${queryString.join('&')}`;

  window.location.href = link;
};
